if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
        let currentMedia
        for(let item of variantsInfo){
          if(item.id == currentVariant){
            currentMedia = item.media
          }
        }
        let currentElements = document.querySelectorAll('[data-media-id="'+currentMedia+'"]')
        currentElements.forEach(element => {
          element.style.display = 'block'
        });
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          console.log(element.getAttribute('data-media-id'))
          if (element.getAttribute('data-media-id') === this.openedBy.getAttribute('data-media-id')) {
            element.classList.add('active'); // Agrega la clase 'active' si coincide
          } else {
            element.classList.remove('active'); // Elimina la clase 'active' si no coincide
          }
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
